import { render, staticRenderFns } from "./IntroductionMoreInformationModal.vue?vue&type=template&id=336878be"
import script from "./IntroductionMoreInformationModal.vue?vue&type=script&lang=js"
export * from "./IntroductionMoreInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports